import { Check } from "lucide-react";

const ProgressBar = ({ steps, currentStep }) => {
  return (
    <div className={`flex items-center justify-center w-full mb-2 mt-2 `}>
      {/* Center the container */}
      <div className="flex items-center justify-between w-full lg:w-full max-w-4xl">
        {" "}
        {/* Adjust width and alignment */}
        {steps.map((step, index) => (
          <div
            key={step}
            className={`flex items-center  ${
              index < steps.length - 1 && "flex-1"
            }`}
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                index === currentStep
                  ? "bg-flamingo-500 text-white font-bold"
                  : "bg-gray-300 text-slate-700 font-normal"
              }`}
            >
              <span className="text-sm">{index + 1}</span>
            </div>
            {index < steps.length - 1 ? (
              <div
                className={`flex-1 h-1 ${
                  index < currentStep ? "bg-flamingo-500" : "bg-slate-300"
                }`}
              ></div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
